import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs/Rx";
import { Api } from "../api/api";
import { Programme } from "../../models";

@Injectable()
export class ProgrammeService {
  private resourceUrl = Api.API_URL + "/appli/programmes";

  constructor(private http: HttpClient) {}

  find(id: number): Observable<Programme> {
    return this.http.get(`${this.resourceUrl}/${id}`);
  }

  getProgrammeInfo(id: number): Observable<any> {
    return this.http.get(`${this.resourceUrl}/${id}/info`);
  }

  findAll(): Observable<any> {
    return this.http.get(`${this.resourceUrl}/home`);
  }
}



// WEBPACK FOOTER //
// ./src/providers/programme/programme.provider.ts